import { createSelector } from "reselect"
import lodash from "lodash"

const root = s => s.User

export const selectUser = createSelector(root, s => s.user)

export const selectUserModules = createSelector(root, s => {
  const modules = lodash
    .values(lodash.get(global.currentUser, "accessibleBookedModules") || {})
    .map(b => b.key)

  // add userModules from url
  if (true || /print_format_labelgroup/.test(window.location)) {
    modules.push("print_format_labelgroup")
  }

  return lodash.uniq(modules)
})
